import axios from 'axios';
import httpBuildQuery from 'http-build-query';
import { getTempId } from '../../models/common';
const BASE_URL = 'api/customers/';

// Инициализируем начальные значения весов для статистики
let initStatWeights = {
  'new': 1,
  'large': 1,
  'medium': 1,
  'small': 1,
  'design': 1,
  'spam': 0,
  'clone': 0
};
let localStatWeights = localStorage.getItem('statWeights');
if (localStatWeights) {
  initStatWeights = JSON.parse( localStatWeights );
}

let exports = {};
exports.namespaced = true;

exports.state = () => ({
  customers: [],
  customersQueryKey: getTempId(),
  customersCount: 0,
  filter: null,
  leads: [],
  statistic: null,
  statWeights: initStatWeights,
  loading: {
    list: 0,
    stat: 0,
    create: 0,
    update: 0,
  },
  statuses: [
    {
      text: 'Неразобрано',
      value: 'new'
    },
    {
      text: 'Капитальный ремонт',
      value: 'large' 
    },
    {
      text: 'Частичный ремонт',
      value: 'medium'
    },
    {
      text: 'Мелкий ремонт',
      value: 'small'
    },
    {
      text: 'Дизайн-проект',
      value: 'design'
    },
    {
      text: 'Не по теме',
      value: 'spam'
    },
    {
      text: 'Дубль',
      value: 'clone'
    }
  ],
});

exports.getters = {
  loadingList: state => state.loading.list != 0,
  loadingStat: state => state.loading.stat != 0,
  loadingCreate: state => state.loading.create != 0,
  loadingUpdate: state => state.loading.update != 0,
  isActiveFilter: state => state.filter && 
    (state.filter.siteId || state.filter.status || state.filter.text || state.filter.start ||
      state.filter.end || state.filter.start_m || state.filter.end_m),
  statMonths: state => state.statistic ? state.statistic.months.map((val, ind) => ({
    value: ind,
    text: val
  })) : [],
  statPerMonth: state => state.statistic ? state.statistic.statPerMonth : []
}

exports.mutations = {
  SET_CUSTOMER_DATA(state, customer) {
    let item = state.customers.find(x => x._id == customer._id);
    if (item) {
      item.firstName = customer.firstName;
      item.middleName = customer.middleName;
      item.lastName = customer.lastName;
      item.fullName = customer.fullName;

      item.email = customer.email;
      item.status = customer.status;
      item.statusText = customer.statusText;
      item.parent = customer.parent;
      item.comment = customer.comment;
    }
  },
  SET_CUSTOMERS_LIST(state, { customers, customersCount, filter, leads }) {
    state.customers = customers;
    state.customersCount = customersCount;
    state.filter = filter;
    state.leads = leads;
    state.customersQueryKey = getTempId();
  },
  SET_STATISTIC(state, statistic) {
    state.statistic = statistic;
  },
  SET_LOADING_STATUS(state, action) {
    state.loading[action]++;
  },
  REMOVE_LOADING_STATUS(state, action) {
    state.loading[action]--;
  },
  SET_WEIGHTS(state, weights) {
    state.statWeights = weights;
  }
};

exports.actions = {
  async loadList({ commit, state, dispatch }, filter) {
    commit('SET_LOADING_STATUS', 'list');
    try {
      if (!filter) filter = state.filter;
      let res = await axios.get(BASE_URL + '?' + httpBuildQuery(filter));
      let leads = [];
      res.data.customers.forEach(element => {
        //element.leads.sort((a, b) => a.createdAt > b.createdAt ? -1 : 1);
        leads.push(...element.leads.map(x => ({
          ...x,
          customer: element
        })));
      });
      leads.sort((a, b) => a.createdAt > b.createdAt ? -1 : 1);
      commit('SET_CUSTOMERS_LIST', {
        customers: res.data.customers,
        customersCount: res.data.count,
        filter,
        leads
      });
    } catch(err) {
      dispatch('showMessage', err.response.data.message, { root: true });
    } finally {
      commit('REMOVE_LOADING_STATUS', 'list');
    }
  },

  async loadSingle({ commit, state, dispatch }, id) {
    try {
      let res = await axios.get(BASE_URL + '?id=' + id);
      if (res.data.count > 0) {
        res.data.customers[0].leads.sort((a, b) => a.createdAt > b.createdAt ? -1 : 1);
        return res.data.customers[0];
      } else {
        throw {
          response: {
            data: {
              message: 'Не удалось загрузить клиента №' + id
            }
          }
        }
      }
    } catch(err) {
      throw err.response.data;
    }
  },

  async create({ commit, dispatch }, customer) {
    commit('SET_LOADING_STATUS', 'create');
    try {
      let res = await axios.post(BASE_URL + 'register-add/' + customer.site, customer);
      dispatch('loadList');
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'create');
    }
  },

  async update({ commit, dispatch }, customer) {
    commit('SET_LOADING_STATUS', 'update');
    try {
      let res = await axios.patch(BASE_URL + customer._id, customer);
      commit('SET_CUSTOMER_DATA', res.data.customer);
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'update');
    }
  },

  async loadStat({ commit, dispatch }) {
    commit('SET_LOADING_STATUS', 'stat');
    try {
      let res = await axios.get(BASE_URL + 'stat');
      commit('SET_STATISTIC', res.data);
    } catch(err) {
      dispatch('showMessage', err.response.data.message, { root: true });
    } finally {
      commit('REMOVE_LOADING_STATUS', 'stat');
    }
  },

  async loadPublicStat({ commit, dispatch }) {
    try {
      let res = await axios.get(BASE_URL + 'public-stat');
      return res.data;
    } catch(err) {
      dispatch('showMessage', err.response.data.message, { root: true });
    } finally {
    }
  },

  setWeights({ commit }, weights) {
    commit('SET_WEIGHTS', weights);
    localStorage.setItem('statWeights', JSON.stringify( weights ));
  }

}

export default exports;